// SEO ACCORDIONS ON CONTENT PAGES

var acc = document.getElementsByClassName("seo-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}

// BLADE CITY STICKY HEADER ----  

if ($('.oms-sticky-active').length){

  $('header.main-header').addClass('oms-sticky');
  var hh = $('header.main-header').outerHeight();
  
  $(window).scroll(function() {
    if ($(window).scrollTop() > hh) {

      $('header.main-header').addClass('oms-sticky-on');
      $('.website-wrapper').css({'padding-top': hh, 'transition': 'none'})

    } else {

      $('header.main-header').removeClass('oms-sticky-on');
      $('.website-wrapper').css('padding-top','');
    };
  });

};

// REINITIATE BRAND SLIDER TO SHOW 4 ON MOBILE / OMS SLIDER TO SHOW 3 ON MOBILE

function reinitializeCarousels() {
    
  const targetCarousel = $('#carousel-gl_section_categories_furniture_3MaJgt.gl_carousel_data');

    // Check if the screen width is less than 767px first
    if (window.matchMedia('(max-width: 767px)').matches) {
        // Continuously check if the carousel is initialized
        const checkInterval = setInterval(function() {
            
          // Check if the carousel is already initialized
            if (targetCarousel.hasClass('owl-loaded')) {
                // Destroy the existing carousel
                targetCarousel.trigger('destroy.owl.carousel');

                // Reinitialize with new settings for mobile view
                targetCarousel.owlCarousel({
                    items: 6,
                    nav: true,
                    responsive: {
                      1024: { items: 6 },
                      768: { items: 4 },
                      0: { items: 4 }
                    }
                });

                // Clear the interval once reinitialized
                clearInterval(checkInterval);
            }
          
        }, 200); // Check every 200ms
    }

  const omsCarousel = $('.oms-carousel-section .gl_carousel_data');
  
  // Check if the screen width is less than 767px first
    if (window.matchMedia('(max-width: 767px)').matches) {

        // Continuously check if the carousel is initialized
        const checkInterval2 = setInterval(function() {
            if (omsCarousel.hasClass('owl-loaded')) {
                // Destroy the existing carousel
                omsCarousel.trigger('destroy.owl.carousel');

                // Reinitialize with new settings for mobile view
                omsCarousel.owlCarousel({
                    items: 6,
                    nav: true,
                    responsive: {
                      1024: { items: 6 },
                      768: { items: 4 },
                      0: { items: 3 }
                    }
                });

                // Clear the interval once reinitialized
                clearInterval(checkInterval2);
            }
          
        }, 200); // Check every 200ms
    }
}

/* COLLECTION PAGE DESCRIPTION READ MORE */

document.addEventListener("DOMContentLoaded", function() {
  var wrapper = document.querySelector('.oms-description-wrapper');
  // Exit if the wrapper doesn't exist.
  if (!wrapper) return;
  
  var toggleButton = document.getElementById('toggle-description');
  var fadeOverlay = wrapper.querySelector('.fade-overlay');
  
  // You can adjust the threshold as needed. Here, we use 100px.
  if (wrapper.scrollHeight <= 100) {
    // If the description is very short, remove the max-height constraint,
    // hide the fade overlay and the toggle button.
    wrapper.style.maxHeight = "none";
    if (fadeOverlay) {
      fadeOverlay.style.display = "none";
    }
    if (toggleButton) {
      toggleButton.style.display = "none";
    }
  }
});

function toggleDescription() {
  var wrapper = document.querySelector('.oms-description-wrapper');
  var button = document.getElementById('toggle-description');

  if (wrapper.classList.contains('expanded')) {
    // Collapse: revert to default max height
    wrapper.classList.remove('expanded');
    wrapper.style.maxHeight = '100px'; // Should match your CSS initial max-height
    button.innerText = 'Read More';
  } else {
    // Expand: animate to the full height (using scrollHeight)
    wrapper.classList.add('expanded');
    wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
    button.innerText = 'Read Less';
  }
}

jQuery(function($) {

  reinitializeCarousels();
  
  if ($('.template-collection').length){
  
    $(window).scroll(function() {
      
      if ($(window).scrollTop() > 450) {		
        $('.canvas-icon').addClass('show');
      } else {   
        $('.canvas-icon').removeClass('show');
      };
      
    });
    
  };
  
  // CATEGORY MOBILE DRAWER ---
  $('.website-wrapper').on('click','.canvas-icon, .close-mobile-canvas, .mobile-filters', function(event) {
    
    console.log('BUTTON CLICKED');
    
    if(!$('body').hasClass('mobile-canvas-shown')) {
      
      console.log('OPEN');
      
      $('body').addClass('mobile-canvas-shown', function() {
        setTimeout(function(){
          $(document).on('click',function(e) {
            var target = e.target;
            if (!$(target).is('.block-main-canvas') && !$(target).parents().is('.block-main-canvas #shopify-section-gl_section_sidebar_shop')) {
              $('body').removeClass('mobile-canvas-shown');
            }
          });
        }, 111);
      });
    } else{
      console.log('CLOSE');
      $('body').removeClass('mobile-canvas-shown');
    }
  });
  
  /* script moved to jquery-1-11.liquid to be printed on page ---
  
  // move product title to right on desktop ---
  if (window.innerWidth >= 767){
  	$('.basel-scroll-content').prepend($('.oms-title-review'));
    
  }
  */
  
  console.log(window.innerWidth);
  
  if (window.innerWidth <= 991){
    // move navigation slide to active menu item ---
    // append "more" drop-down items to main menu ul ---
    //$('div.basel-product-categories:not(.show-dropdowns) li .children').children().appendTo('.basel-product-categories');
    
    if ($('.show-dropdowns').length){
      
      $('header').append('<div class="navigation-subs"></div>');
      
      setTimeout(function(){ 
        $('ul.children').each(function(index){
          $(this).appendTo('.navigation-subs');
        }); 
      }, 300);
      
    } else {
      
    	$('.basel-product-categories li .children').children().appendTo('.basel-product-categories');
      $('.dd-close-mobile').remove();
    }

    setTimeout(function(){ 
      var current = $('.cat-item.current-cat').position();
      if (current != undefined){
      	$('.basel-product-categories').scrollLeft(current.left - 10);
      }
    }, 100);
    
    
    $('.show-dropdowns').on('click', '.has-sub a', function(e){
      
      e.preventDefault();
      
      $('.open-sub').slideUp(200);

      if ($(this).hasClass('sub-active')){
			location.href = $(this).attr('href');
		} else {
			$('.sub-active').removeClass('sub-active');
			$(this).addClass('sub-active');
          
          var openTarget = ($(this).parent().data('item'));
          $('ul[data-child-item="' + openTarget +'"]').addClass('open-sub').slideDown(400);
      }
      
      $('.dd-close-mobile a').on('click', function(e){
      	$('.open-sub').slideUp(200);
        $('.sub-active').removeClass('sub-active');
      });
      
    });
    

    /*
    $('???').on('click', function() {
      var leftPos = $('.basel-product-categories').scrollLeft();
      $('.basel-product-categories').animate({
        scrollLeft: leftPos - 200
      }, 600);
    });

    $('???').on('click', function() {
      var leftPos = $('.basel-product-categories').scrollLeft();
      $('.basel-product-categories').animate({
        scrollLeft: leftPos + 200
      }, 600);
    });
    */
  }


  // SHIPPING MESSAGE TIME & LOGIC ---
  if ($('.oms-shipping-message').length){  

    var dt = new Date();
    dt.setTime(dt.getTime()+dt.getTimezoneOffset()*60*1000);
    var offset = -300; //Timezone offset for EST in minutes.
    var estDate = new Date(dt.getTime() + offset*60*1000);

    /* testing tools ---
    var estDate = "Sun Nov 06 2018 11:55:41 GMT-0500 (Eastern Standard Time)"
    console.log(estString);
    console.log(estTime);
    console.log(estString[0]);
    */

    //Current Miami Time
    var estString = estDate.toString().split(" ");
    var estTime = estString[4].split(":");

    if (estString[0] != "Fri" && estString[0] != "Sat" && estString[0] != "Sun"){

      // weekdays monday-thursday ---
      //console.log('BLOCK: WEEKDAY fired');

      // before 5 ships today, after 5 ships tomorrow ---
      if (parseInt(estTime[0]) < 17){
        $('.oms-shipping-message span').text('ships today');
        //console.log('CASE: weekday before 5 fired');
      } else {
        $('.oms-shipping-message span').text('ships tomorrow');
        //console.log('CASE: weekday after 5 fired');
      }

    } else {  

      // weekends friday-sunday ---
      //console.log('BLOCK: WEEKEND fired');

      // friday before 5pm ships today, otherwise ships on monday ---
      if (estString[0] == "Fri" && parseInt(estTime[0]) < 17){
        $('.oms-shipping-message span').text('ships today');
        //console.log('CASE: friday before 5 fired');
      } else {
        $('.oms-shipping-message span').text('ships tomorrow');
        //console.log('CASE: friday after 5 fired');
      }

      // sunday all day ships tomorrow ---
      if (estString[0] == "Sun"){
        $('.oms-shipping-message span').text('ships tomorrow');
        //console.log('CASE: sunday fired');
      }

    }
  }
  
  
  // set shipping message based on variant ---
  if (!$('.add_to_cart_button').is(':visible')){
  	$('.oms-shipping-container').addClass('unavailable');
  }
  
  $('.basel-swatch').on('click', function(e){
    if ($(this).hasClass('jas_soldout')) {
      $('.oms-shipping-container').addClass('unavailable');
    } else {
      $('.oms-shipping-container').removeClass('unavailable');
    }
  });
  
  
  // full screen search overrides ---
  /*
  $('body').on('blur','.ui-autocomplete-input', function(){
    $('ul.ui-autocomplete').addClass('oms-stay-open');
  });


  $('body').on('click','.basel-close-search, header', function(){	
    $('ul.ui-autocomplete').removeClass('oms-stay-open');
  });
  */
  
  // Find all YouTube videos ---
  var allVideos = $("iframe[src*='youtube.com']");

  // wrap video if not already wrapped ---
  allVideos.each(function() {
    
    if (!$(this).parent().hasClass('video-wrap')) {
      
    	$(this).wrap("<div class='video-wrap'></div>");
    }
    
  });
  
  
  
  /* FLOATING ICON */
  
  // count items and update icon number ---
  $('.icon-count').text($('.bc-icon-info').length);

  //console.log(sessionStorage.getItem('bc-icon'));

  if (sessionStorage.getItem('bc-icon') == null) {
    $('.icon-container').addClass('on');
  }

  // hide icon --- 
  $('.icon-close').on('click', function(e){
    sessionStorage.setItem('bc-icon','false');
    $('.icon-container').removeClass('on');
  });
  

  $('.popup-with-move-anim').magnificPopup({
    type: 'inline',

    fixedContentPos: false,
    fixedBgPos: true,

    overflowY: 'auto',

    closeBtnInside: true,
    preloader: false,

    midClick: true,
    removalDelay: 300,
    mainClass: 'my-mfp-slide-bottom'
  });
  
  
  // CARTHOOK COUPON ---
  
  $('#coupon_code').on('blur', function(e){
  	window.chCouponCode = $(this).val();
  });
  
  
  
});


